import { render } from "./ContestIndividual.vue?vue&type=template&id=37add826&scoped=true"
import script from "./ContestIndividual.vue?vue&type=script&lang=js"
export * from "./ContestIndividual.vue?vue&type=script&lang=js"

import "./ContestIndividual.vue?vue&type=style&index=0&id=37add826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37add826"]])

export default __exports__